import { createColumnHelper } from '@tanstack/react-table';
import _ from 'lodash';
import { formatDistanceToNow } from 'date-fns';

import { isoDateFromTimestamp } from '@/portainer/filters/filters';
import { AutoPatch } from '@/react/portainer/settings/types';

import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { StatusBadge } from './StatusBadge';

const columnHelper = createColumnHelper<AutoPatch>();

export const columns = _.compact([
  columnHelper.accessor('version', {
    header: 'Version',
    cell: ({ getValue }) => getValue(),
    enableSorting: true,
  }),
  columnHelper.accessor('startedAtUnix', {
    header: 'Date & Time',
    cell: ({ getValue }) => {
      const date = isoDateFromTimestamp(getValue());
      return (
        <TooltipWithChildren message={date}>
          <span>{formatDistanceToNow(date, { addSuffix: true })}</span>
        </TooltipWithChildren>
      );
    },
    enableSorting: true,
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: ({ getValue, row: { original: item } }) => {
      const tooltip =
        item.doneAtUnix > 0
          ? isoDateFromTimestamp(item.doneAtUnix)
          : 'In progress';
      return (
        <TooltipWithChildren message={tooltip}>
          <span>
            <StatusBadge status={getValue()} />
          </span>
        </TooltipWithChildren>
      );
    },
    enableSorting: true,
  }),
]);
